{
    "name": "Tomatillo",
    "binomial_name": "Physalis philadelphica",
    "common_names": [
        "Husk tomato",
        "Mexican husk tomato"
    ],
    "description": "The tomatillo is a member of the Nightshade family. The plant bears a resemblance to tomato plants and benefits from pruning and trellising. The fruit of the tomatillo plant is small, round, and green or purple. It is covered in a paper husk that splits open when the fruit is ready for harvest. Tomatillos are native to Mexico and can be eaten raw or cooked. They have a citrusy, tart, and tangy lemon flavor.",
    "sun_requirements": "Full Sun",
    "sowing_method": "Direct seed indoors, transplant seedlings outside after hardening off",
    "spread": 90,
    "row_spacing": 60,
    "height": 100,
    "growing_degree_days": 0,
    "companions": [],
    "image": "/crops/images/tomatillo.jpg",
    "icon": "/crops/icons/tomatillo.avif"
}